import type { ButtonHTMLAttributes, ReactNode } from 'react';

import styles from './MenuItem.module.css';

interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  /** A decorative glyph (the label already names the action, so the icon is `aria-hidden`). */
  icon?: ReactNode;
  children: ReactNode;
  danger?: boolean;
  /** Something after the label: a chevron that opens a sub-view, a current value. */
  trailing?: ReactNode;
}

/** One row of an action menu: a leading icon column, then the text. Renders inside `<li>`. */
export function MenuItem({ icon, danger = false, trailing, className, children, ...props }: Props) {
  return (
    <button
      type="button"
      className={[styles.item, danger && styles.danger, className].filter(Boolean).join(' ')}
      {...props}
    >
      <span className={styles.icon} aria-hidden="true">
        {icon}
      </span>
      <span className={styles.label}>{children}</span>
      {trailing !== undefined && (
        <span className={styles.trailing} aria-hidden="true">
          {trailing}
        </span>
      )}
    </button>
  );
}
